'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoEye = function IoEye(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm17.5 10c7.7 0 13.4 5.5 17.5 10.1-4 3.9-9.7 9.9-17.5 9.9s-12.3-4.7-17.5-10c6.1-6.2 11.1-10 17.5-10z m0 17.1c3.8 0 7-3.2 7-7.1s-3.2-7.1-7-7.1-7 3.2-7 7.1 3.2 7.1 7 7.1z m0-9.6c0 1.4 1.1 2.5 2.5 2.5 0.6 0 1.1-0.2 1.6-0.5v0.5c0 2.3-1.8 4.1-4.1 4.1s-4.1-1.8-4.1-4.1 1.8-4.1 4.1-4.1h0.6c-0.4 0.4-0.6 1-0.6 1.6z' })
        )
    );
};

exports.default = IoEye;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/eye.js
// module id = 2050
// module chunks = 0